import { allTrackers } from "app/services/track/track";

import createManagementTrackingService from "./factory";

const managementTrackingService = createManagementTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default managementTrackingService;
